import { useQuery } from '@tanstack/react-query'
import { personsApi, type Person } from '@/lib/api/client'
import { useAuthStore } from '@/stores/authStore'
import { useProjectStore } from '@/stores/projectStore'

export function usePersons() {
  const { currentAccount } = useAuthStore()
  const { currentProject } = useProjectStore()

  return useQuery<Person[]>({
    queryKey: ['persons', currentAccount?.id, currentProject?.id],
    queryFn: async () => {
      if (!currentAccount || !currentProject) {
        return []
      }
      return personsApi.list(currentAccount.id, currentProject.id)
    },
    enabled: !!currentAccount && !!currentProject,
    staleTime: 30000, // 30 seconds
  })
}

export function usePerson(personId: string | undefined) {
  const { currentAccount } = useAuthStore()
  const { currentProject } = useProjectStore()

  return useQuery<Person | null>({
    queryKey: ['person', currentAccount?.id, currentProject?.id, personId],
    queryFn: async () => {
      if (!currentAccount || !currentProject || !personId) {
        return null
      }
      return personsApi.get(currentAccount.id, currentProject.id, personId)
    },
    enabled: !!currentAccount && !!currentProject && !!personId,
    staleTime: 30000,
  })
}
